/**
 * What Session Replay may record (entry.client.tsx): the page's layout and
 * clicks, never what is on it.
 *
 *  - Every text node and every input value is masked (`***`), on customer,
 *    office and provider pages alike: names, addresses, emails, phones and
 *    order details never leave the browser.
 *  - Text-like attributes are masked too (with maskAllText on, Replay masks
 *    the attributes listed here); a payment element's session key is one.
 *  - Images, video, SVG, canvas and every iframe are blocked (an empty box of
 *    the same size): listing photos, maps and street views, and embedded
 *    payment fields. Any element carrying a `session-key` attribute (the
 *    embedded payment, onboarding and report components) or `.sentry-block`
 *    is blocked whole, children included.
 *  - Keystrokes in password and card fields are not recorded at all.
 *  - No request or response bodies or headers: network entries keep only
 *    method, status, timing and a URL that lib/sentry-scrub.ts has already
 *    stripped of credentials and personal query parameters.
 */
export const REPLAY_PRIVACY = {
  maskAllText: true,
  maskAllInputs: true,
  blockAllMedia: true,
  mask: ['.sentry-mask', '[data-sentry-mask]'],
  maskAttributes: ['title', 'placeholder', 'aria-label', 'alt', 'value', 'session-key', 'data-filters'],
  block: ['iframe', 'canvas', '[session-key]', '.sentry-block', '[data-sentry-block]'],
  ignore: [
    'input[type="password"]',
    '[autocomplete^="cc-"]',
    '[autocomplete="one-time-code"]',
    '.sentry-ignore',
    '[data-sentry-ignore]',
  ],
  networkCaptureBodies: false,
  networkDetailAllowUrls: [] as (string | RegExp)[],
  networkRequestHeaders: [] as string[],
  networkResponseHeaders: [] as string[],
};
